import { call, put, takeEvery } from "redux-saga/effects"
import { LOGIN_USER,
  FORGET_PASSWORD,
  RESET_PASSWORD,
  CUSTOMER_USER,
  HASH_VALIDATE,
  /**register Esignature */
  REGISTER_CLEAR_DATA,
  REGISTER
} from "./actionTypes"
import {
  apiError,
  loginSuccess,
  forgetPasswordSuccess,
  forgetPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
  hashValidateSuccess,
  hashValidateError,
  customerError,
  customerSuccess,
  /**Esignature register */
  registerClearData,
  registerError,
  registerSuccess,
} from "./actions"
import { toast } from 'react-toastify';

import {
  postLogin,
  postResetPassword,
  postHashValidate,
  getBillingCustomersNotFull,
  /**Esignature register */
  putEsignatureUser,
} from "../../helpers/call_api"
import { sendResetLink } from "../../services/ocr"


function* loginUser({ payload: { user } }) {
  try {
    const response = yield call(postLogin, user)
    yield put(loginSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}


function* getCustomers({ payload: { customer, navigate } }) {
  try {
    const response = yield call(getBillingCustomersNotFull, customer)
    yield put(customerSuccess(response))
  } catch (error) {
    if (error.response.status) {
      if (error.response.status === 401) {
        navigate('/login');
      }
    }
    toast.error(error?.response?.data?.error?.messages[0].message);
    yield put(customerError(error))
  }
}

//forget password – GET SendResetLink/{email} (no auth; optional customerId)
function* forgetPassword({ payload: { user, navigate } }) {
  try {
    const email = user?.data?.email || user?.email;
    if (!email) {
      toast.error("Email is required.");
      yield put(forgetPasswordError(new Error("Email is required.")));
      return;
    }
    const customerId = user?.customerId ?? null;
    yield call(sendResetLink, email, customerId);
    yield put(forgetPasswordSuccess({ success: true }));
  } catch (error) {
    const data = error?.response?.data;
    const messages = data?.error?.messages;
    const message =
      Array.isArray(messages) && messages.length > 0
        ? messages.map((m) => m.message).join(" ")
        : error?.message || "We were not able to process your request. Try again later.";
    toast.error(message);
    yield put(forgetPasswordError(error));
  }
}

//reset password – PUT SystemUserPublic/ResetPassword with hashcode token (public endpoint)
function* resetPassword({ payload: { user, navigate } }) {
  try {
    // 204 No Content on success
    yield call(postResetPassword, user);
    yield put(resetPasswordSuccess({ success: true }));
  } catch (error) {
    const data = error?.response?.data;
    const messages = data?.error?.messages;
    const message =
      Array.isArray(messages) && messages.length > 0
        ? messages.map((m) => m.message).join(" ")
        : error?.message || "We were not able to reset your password. Try again later.";
    toast.error(message);
    yield put(resetPasswordError(error));
  }
}

//hash validate
function* hashValidate({ payload: { user, navigate } }) {
  try {
    const response = yield call(postHashValidate, user);
    yield put(hashValidateSuccess(response));
  } catch (error) {
    toast.error(error.message);
    yield put(hashValidateError(error));
  }
}

/**Register esignature */
function* registerClearDataEsignature() {
  try {
    yield put(registerClearData())
  } catch (error) {
    yield put(registerError(error))
  }
}

function* registerEsignatureUser({ payload: { userId, user, navigate } }) {
  try {
    const response = yield call(putEsignatureUser, userId, user);
    yield put(registerSuccess(response));
  } catch (error) {
    if (error.response.status) {
      if (error.response.status === 401) {
        navigate('/login');
      }
    }
    console.log(error);
    yield put(registerError(error));
  }
}
/**END */

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(FORGET_PASSWORD, forgetPassword);
  yield takeEvery(RESET_PASSWORD, resetPassword);
  yield takeEvery(HASH_VALIDATE, hashValidate);
  yield takeEvery(CUSTOMER_USER, getCustomers);
  /**esignature register */
  yield takeEvery(REGISTER_CLEAR_DATA, registerClearDataEsignature);
  yield takeEvery(REGISTER, registerEsignatureUser);
}

export default authSaga
